import { createFileRoute } from '@tanstack/react-router'
import EvidenceCreatingPage from '@/pages/(protected)/workspaces/[workspaceId]/evidence/creating'

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/evidence/creating')({
  component: EvidenceCreatingPage,
})
